import { render, staticRenderFns } from "./video-modal.vue?vue&type=template&id=65e1bc74"
import script from "./video-modal.vue?vue&type=script&lang=js"
export * from "./video-modal.vue?vue&type=script&lang=js"
import style0 from "./video-modal.vue?vue&type=style&index=0&id=65e1bc74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports